import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import "./index.css";
import "./i18n";
import { initializeTheme } from "./store/theme";

// Initialize theme before rendering
initializeTheme();

// Cache agressivo: a maioria das listagens (users, squads, agents,
// tags) não mudam frequentemente, então mantemos os dados em memória
// 30 minutos e não revalidamos no foco da janela. Mutations
// relevantes invalidam manualmente via queryClient.invalidateQueries.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,    // 5min sem refetch automático
      gcTime: 30 * 60 * 1000,      // 30min em cache após desmontar
      refetchOnWindowFocus: false, // não refetch ao voltar pra aba
      refetchOnReconnect: "always",
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
